export const URL_API: string   = process.env.REACT_APP_STP_TOOLBOX_API ?? '/api/';
export const URL_FILES: string = process.env.REACT_APP_STP_TOOLBOX_FILES ?? '/files/';